(function () {
    'use strict';

    angular.module("imApp").factory("modelMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1161,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1164,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
